import React from 'react'
import "../styles/homePage.css"
import { Link } from 'react-router-dom'
import Layout from '../components/Layout/Layout.jsx'

const HomePage = () => {
  return (
   <Layout title="Lastbites">
    <div className='main'>  
      <div className='mainBgImg'>
        {/* <img className='mainImg' src="https://img.freepik.com/premium-photo/donation-box-with-food-old-wooden-background_104376-1486.jpg" alt="" /> */}
        {/* <img className='mainImg' src="/Resources/donation-box-with-food-old-wooden-background_104376-1486.avif" alt="" /> */}
        <img className='mainImg' src="/Resources/BGLogo.jpg" alt="" />

      </div>
      <div className='main1'>
        <h1 className='text-green-400 font-bold main1Head '>   <span className='text-gray-200'> Food </span>Donation <span className='text-gray-200'></span></h1>

        <h1 className='text-4xl font-bold text-white mt-16 main1Head'>Don't Waste Just Donate</h1>

        <div className="main1Btn"><Link className='bg-green-600 text-white hover:bg-green-500 LinkBtn' to={"/donate"}>Donate Food</Link><Link className='bg-green-600 text-white hover:bg-green-500 LinkBtn' to={"/foodlist"}>Need Food</Link></div>

      </div>
      <div className="main2">
        <h1 className='text-4xl font-bold text-white main2Head' >Our Works</h1>
        <div className="ourWork">
          <div className="ourWorkCard"><h1 className="workh1">“At Lastbites, we connect surplus food from hotels and homes to families in need, fighting hunger and reducing waste. Together, we strive for a hunger-free future, one meal at a time.”</h1></div>
        </div>
      </div>
      <div className="main2">
        <h1 className='text-4xl font-bold text-white main2Head' >About Us</h1>
        <div className="ourWork">
          <div className="ourWorkCard"><h1 className="workh1">At Lastbites, we are committed to fighting hunger in our community. We connect surplus food from donors, including leftover food from hotels, marriage halls, and homes, to families in need and local NGOs, ensuring that no meal goes to waste. Our programs provide nutritious meals, empowering those facing food insecurity and promoting better health. By partnering with local organizations and volunteers, we maximize our impact and raise awareness about food security. Together, we can reduce food waste and create a hunger-free future, one meal at a time.</h1></div>
        </div>
      </div>
    
     
       
    </div>
    </Layout>

  )
}

export default HomePage